export const AGE_MIN = 0
export const AGE_MAX = 150

export const CHECKBOX_WIDTH = 40
